import { Link, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './OfferGroup.css';

interface IOfferGroup {
  count?: string;
  link?: string;
  name?: string;
}

interface IOfferGroupProps {
  offerGroup: IOfferGroup;
  textLink: string;
  offers: React.ReactNode;
  onClick: () => void;
  position: number;
}

export const OfferGroup = ({ offerGroup, offers, position, textLink, onClick }: IOfferGroupProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']} data-name="OfferGroupHeader">
        <UIHeading2>{offerGroup.name}</UIHeading2>
        {Number(offerGroup.count) > 1 && (
          <Link target="_blank" href={offerGroup.link} onClick={onClick} fontSize="S">
            {textLink}
          </Link>
        )}
      </div>
      <div key={`offers_${position}`} className={styles['offers-wrapper']}>
        {offers}
      </div>
    </div>
  );
};
